<template>
<widget :title="'App - '+app.app_name" icon="fa-th-large" :no-padding="true">
	<div class="addon-app-body" :style="{height: iframeHeight}">
		<iframe :src="iframeSrc"></iframe>
	</div>
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import AppsMixins from "@/mixins/AppsMixins.js"

export default {
	name: "AddonAppWidget",
	mixins: [AppsMixins],
	components: {
		Widget
	},
	props: ["app","maxHeight"],
	data() {
		return {
			iframeSrc: "",
			uiLocation: "Dashboard Widget"
		}
	},
	watch: {
		app: {
			immediate: true,
			handler(app) {
				let vm = this

				this.iframeSrc = ""
				if (!app)
					return

				this.resolveAddonAppIframeSrc(app).then(src => {
					if (vm.app && vm.app.id == app.id)
						vm.iframeSrc = src
				})
			}
		}
	},
	computed: {
		iframeHeight() {
			if (this.maxHeight)
				return this.maxHeight

			return "350px"
		}
	}
}
</script>

<style type="text/css" scoped>
	.addon-app-body {
		overflow: hidden;
	}

	iframe {
		width: 100%;
		height: 100%;
		border: none;
		display: block;
	}
</style>
